/* @flow */
import * as React from 'react';

const GiftBox = props => (
  <svg
    width={88}
    height={88}
    viewBox="0 0 88 88"
    stroke="none"
    strokeWidth={1}
    fillRule="nonzero"
    {...props}>
    <path
      fill="#FFCC66"
      d="M3,36 L3,82.524 C3,85.548 5.479,88 8.533,88 L80.467,88 C83.521,88 86,85.548 86,82.524 L86,36 L3,36 Z"
    />
    <path
      fill="#E6B85C"
      d="M82.5,19 L5.5,19 C2.464,19 0,21.464 0,24.5 L0,41 L88,41 L88,24.5 C88,21.464 85.536,19 82.5,19 Z"
    />
    <rect fill="#ED7161" x={36} y={41} width={16} height={47} />
    <rect fill="#BA594C" x={36} y={19} width={16} height={22} />
    <circle fill="#BA594C" cx={44.5} cy={19.5} r={5.5} />
    <path
      fill="#ED7261"
      fillRule="evenodd"
      d="M28,0 C22.5,0 17,5.429 17,10.857 C17,19 39,19 39,19 C39,19 36.25,0 28,0 Z M25.25,10.857 C25.25,9.234 26.196,5.429 28,5.429 C30.75,5.429 33.5,16.286 33.5,16.286 C33.5,16.286 25.25,13.403 25.25,10.857 Z"
    />
    <path
      fill="#ED7261"
      fillRule="evenodd"
      d="M61,0 C52.75,0 50,19 50,19 C50,19 72,19 72,10.857 C72,5.429 66.5,0 61,0 Z M55.5,16.286 C55.5,16.286 58.25,5.429 61,5.429 C62.804,5.429 63.75,9.234 63.75,10.857 C63.75,13.403 55.5,16.286 55.5,16.286 Z"
    />
  </svg>
);

export default GiftBox;



// WEBPACK FOOTER //
// ./src/assets/images/icons/gift-box.js